import { I18nHelper } from "../../Lib/Helper/I18nHelper";


export class AxCheck {
    private label: HTMLElement;
    private checkBoxInstance: IAxCheckBoxInstance;
    public  identifier: string;

    constructor(identifier: string, label: HTMLElement) {
        this.label = label;
        this.identifier = identifier;
        this.checkBoxInstance = {
            checkBoxWrapper: label,
            valueElem: label.children[0] as HTMLElement,
            spanElem: label.children[1] as HTMLElement
        }
    }

    static Init(identifier: string, label: HTMLElement): AxCheck {
        return new AxCheck(identifier, label);
    }

    setSpanValue(newValue: string) {
        this.checkBoxInstance.spanElem.innerHTML = '(' + newValue + ')';
    }

    resetCheckBox() {
        const checkbox = this.checkBoxInstance.valueElem as HTMLInputElement;
        checkbox.checked = false;
    }

    hideCheckBox() {
        $(this.checkBoxInstance.checkBoxWrapper).hide();
    }

    showCheckBox() {
        $(this.checkBoxInstance.checkBoxWrapper).show();
    }
}

interface IAxCheckBoxInstance {
    checkBoxWrapper: HTMLElement;
    spanElem: HTMLElement;
    valueElem: HTMLElement;
}